import tw from "twin.macro"
import { CarCareBackButtonProps } from "./CarCareBackButton.d"
import { useContext } from "react"
import { LanguageContext } from "../../../contexts/Language"
import Back from "../../atoms/Back/Back"

const CarCareBackButton = ({ pathname }: CarCareBackButtonProps) => {
  const { _ } = useContext(LanguageContext)

  const pathSegments = pathname.split("/")
  pathSegments.pop() // Remove the last segment
  pathSegments.pop() // Remove the second to last segment
  const newPath = pathSegments.join("/")

  return (
    <div css={[tw`text-toyotaRed cursor-pointer my-5`]}>
      <Back cta={_("Back")} link={newPath} />
    </div>
  )
}
export default CarCareBackButton
